import React from 'react';
import ReactDOM from 'react-dom/client';
import './setupSentry';
import './setupFetchWithCredentials';
import './setupIgnoredPromiseRejections';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MaintenanceProvider } from './contexts/MaintenanceContext';
import { ConnectivityProvider } from './contexts/ConnectivityContext';
import { AuthProvider } from './contexts/AuthContext';
import { AdminFeatureFlagsProvider } from './contexts/AdminFeatureFlagsContext';
import { ArtistAuthProvider } from './contexts/ArtistAuthContext';
import { AnnouncementProvider } from './contexts/AnnouncementContext';
import { BugReportingProvider } from './contexts/BugReportingContext';
import { ToastProvider } from './components/common/ToastSystem';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './api/queryClient';
import { ConfirmProvider } from './design-system/ConfirmDialog';
import WebAppUpdateBanner from './components/common/WebAppUpdateBanner';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Application root element was not found.');
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConnectivityProvider>
        <MaintenanceProvider>
          <AuthProvider>
            <AdminFeatureFlagsProvider>
              <ArtistAuthProvider>
                <AnnouncementProvider>
                  <BugReportingProvider>
                    <ToastProvider position="top-right" defaultDuration={2600}>
                      <ConfirmProvider>
                        <App />
                        <WebAppUpdateBanner />
                      </ConfirmProvider>
                    </ToastProvider>
                  </BugReportingProvider>
                </AnnouncementProvider>
              </ArtistAuthProvider>
            </AdminFeatureFlagsProvider>
          </AuthProvider>
        </MaintenanceProvider>
      </ConnectivityProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
